<template>
    <div class="bg-white px-3 index" >
        <div>
             <div class="add_tits" ref="titles">
                <el-form :inline="true" class="form-inlines u-f u-jsb">
                    <div>
                        <el-form-item label="时间:">
                            <el-date-picker v-model="timeValue" type="daterange" range-separator="至" size="small"
                                :clearable="false" value-format="yyyy-MM-dd" start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="search">搜索</el-button>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item>
                            <el-button size="small" icon="el-icon-circle-plus-outline" @click="add" type="primary">新增</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="ibox-content">
                <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
                    ref="configurationTable">
                    <el-table-column prop="date" label="日期" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="tgfy" label="推广费用" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="create_author" label="创建人" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog title="新增" :visible.sync="dialogVisible" top='20px'>
                <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-row :gutter="5">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item label="时间:" prop="date" class="m-b">
                                    <el-date-picker v-model="ruleForm.date" type="date" placeholder="选择时间"
                                        value-format="yyyy-MM-dd" size="small">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="推广费用" prop="tgfy">
                                    <el-input v-model="ruleForm.tgfy" style="max-width: 320px" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <el-divider></el-divider>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                    <el-button @click="subForm('ruleForm')" size='small' type="primary">提交</el-button>
                </span>
            </el-dialog>


            <el-dialog title="修改" :visible.sync="dialogVisibled" top='20px'>
                <el-divider></el-divider>
                <div class="dialog-ibox-content">
                    <el-form :model="ruleForms" :rules="rulesd" ref="ruleForms" label-width="100px"
                        class="demo-ruleForm">
                        <el-row :gutter="5">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item label="时间:" prop="date" class="m-b">
                                    <el-date-picker v-model="ruleForms.date" type="date" placeholder="选择时间"
                                        value-format="yyyy-MM-dd" size="small">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="推广费用" prop="tgfy">
                                    <el-input v-model="ruleForms.tgfy" style="max-width: 320px" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <el-divider></el-divider>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisibled = false" size='small'>取 消</el-button>
                    <el-button @click="EditForm('ruleForms')" size='small' type="primary">提交</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loadings: false,
                timeValue: [],
                tableData: [],
                dialogVisible: false,
                ruleForm: {
                    date: '',
                    tgfy: '',
                },
                rules: {
                    date: [{
                        required: true,
                        message: '请选择日期',
                        trigger: 'blur'
                    }],
                    tgfy: [{
                        required: true,
                        message: '请填写推广费用',
                        trigger: 'blur'
                    }],
                },
                dialogVisibled: false,
                ruleForms: {
                    date: '',
                    tgfy: '',
                },
                rulesd: {
                    date: [{
                        required: true,
                        message: '请选择日期',
                        trigger: 'blur'
                    }],
                    tgfy: [{
                        required: true,
                        message: '请填写推广费用',
                        trigger: 'blur'
                    }],
                },
                eid: '',
                height: null,
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this;
            var titles = that.$refs.titles.offsetHeight
            that.height = window.innerHeight-titles - 150 + 'px'
            window.onresize = () => {
                 var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight-titles - 150 + 'px'
            }
            that.begin()
        },
        methods: {
            begin() {
                let that = this
                that.gettime()
                that.search()
            },
            gettime() {
                let that = this;
                let nowDate = new Date(new Date().getTime())
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                that.timeValue = [
                    year + "-" + month + "-01",
                    year + "-" + month + "-" + day
                ];
            },
            //查询
            search() {
                let that = this
                that.loadings = true
                that.tableData = [];
                axios.defaults.headers.common["token"] = this.user.token;
                axios.post("/admin/getGzhFee", {
                        date1: that.timeValue[0],
                        date2: that.timeValue[1],
                    })
                    .then(response => {
                        that.loadings = false
                        that.tableData = response.data.data
                        this.$refs.configurationTable.$el.style.width = '99.99%'
                    })
                    .catch(error => {})
            },
            //添加
            add() {
                let that = this
                that.dialogVisible = true
                that.ruleForm = {
                    date: '',
                    tgfy: '',
                }
            },
            //新增
            subForm(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios.defaults.headers.common["token"] = this.user.token;
                        axios.post("/admin/addGzhFee", {
                                date: that.ruleForm.date,
                                tgfy: that.ruleForm.tgfy,
                                create_author: this.user.username,
                            })
                            .then(response => {
                                if (response.data.code == 200) {

                                    that.dialogVisible = false
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                    that.search()
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: response.data.msg,
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },

            //编辑
            handleClick(row) {
                let that = this
                that.eid = row.id
                that.dialogVisibled = true
                that.ruleForms.date = row.date
                that.ruleForms.tgfy = row.tgfy
            },
            EditForm(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios.defaults.headers.common["token"] = this.user.token;
                        axios.post("/admin/editGzhFee", {
                                id: that.eid,
                                date: that.ruleForms.date,
                                tgfy: that.ruleForms.tgfy,
                                update_author: this.user.username,
                            })
                            .then(response => {
                                if (response.data.code == 200) {
                                    that.dialogVisibled = false
                                    this.$message({
                                        showClose: true,
                                        type: 'success',
                                        message: response.data.msg
                                    });
                                    that.search()
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: response.data.msg,
                                        type: 'error'
                                    });
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            }

        },
    }
</script>

<style lang="scss" scoped>

</style>